import { render, staticRenderFns } from "./SolicitudReclamacionesForm.vue?vue&type=template&id=960f2062&scoped=true"
import script from "./SolicitudReclamacionesForm.vue?vue&type=script&lang=ts"
export * from "./SolicitudReclamacionesForm.vue?vue&type=script&lang=ts"
import style0 from "./SolicitudReclamacionesForm.vue?vue&type=style&index=0&id=960f2062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960f2062",
  null
  
)

export default component.exports